<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    content-class="newProduct"
  >
    <v-card>
      <v-form ref="form">
        <v-toolbar dark color="pink">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>新增商品</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="$root.$emit('confirmDialog', submit, hint, 'fas fa-exchange-alt')">送出</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-subheader>商品類型</v-subheader>
              <v-subheader>
                <v-select 
                  :items="$product_types" 
                  dense 
                  placeholder="選擇商品類型"
                  v-model="product.product_type"
                  :rules="[$rules.notEmpty]"
                ></v-select>
              </v-subheader>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="product.product_type == 'clothes'">
            <v-list-item-content>
              <v-subheader>衣物類型</v-subheader>
              <v-subheader>
                <v-select 
                  :items="clothes_types" 
                  item-text="name"
                  item-value="num"
                  dense 
                  placeholder="選擇衣物類型"
                  v-model="product.clothes_type"
                  :rules="[$rules.notEmpty]"
                ></v-select>
              </v-subheader>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-subheader>商品標題</v-subheader>
              <v-subheader>
                <v-text-field 
                  dense 
                  v-model="product.title"
                  :rules="[$rules.notEmpty]"
                ></v-text-field>
              </v-subheader>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-subheader>內容 <span class="red--text">*</span></v-subheader>
              <v-textarea outlined class="px-4" v-model="product.remark" :rules="[$rules.notEmpty]" placeholder="請輸入商品描述"></v-textarea>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-subheader>
                <div class="peach"></div>桃子
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small class="ml-2 mt-1" v-bind="attrs" v-on="on">fa-question-circle</v-icon>
                  </template>
                  <div>最小 {{ $product_price_limit[product.product_type] ? $product_price_limit[product.product_type].min : '不限制' }}</div>
                  <div>最大 {{ $product_price_limit[product.product_type] ? $product_price_limit[product.product_type].max : '不限制' }}</div>
                </v-tooltip>
              </v-subheader>
              <v-subheader>
                <v-text-field 
                  dense 
                  v-model="product.price"
                  :rules="[$rules.price(product.price, product.product_type)]"
                ></v-text-field>
              </v-subheader>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-subheader>台幣</v-subheader>
              <v-subheader>
                <v-text-field 
                  dense
                  :value="product.price > 0 ? $func.peach2price(product.price) : 0"
                  disabled
                ></v-text-field>
              </v-subheader>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="product.product_type == 'clothes'">
            <v-list-item-content>
              <v-subheader>使用時間(hour)</v-subheader>
              <v-subheader>
                <v-text-field 
                  dense 
                  v-model="product.use_time"
                  :rules="[$rules.integer]"
                ></v-text-field>
              </v-subheader>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item v-if="['story', 'chat'].includes(product.product_type)">
            <v-list-item-content>
              <v-subheader>動態類型</v-subheader>
              <v-subheader>
                <v-chip-group active-class="pink--text" mandatory v-model="product.story_type">
                  <v-chip outlined class="mr-4" value="video">
                    <v-icon class="mr-2">fas fa-video</v-icon>
                    影片
                  </v-chip>
                  <v-chip outlined value="image">
                    <v-icon class="mr-2">fas fa-images</v-icon>
                    圖片
                  </v-chip>
                </v-chip-group>
              </v-subheader>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="videos.length && 
                             (['story', 'chat'].includes(product.product_type) ? product.story_type == 'video' : true )"
          >
            <v-list-item-content>
              <v-subheader>影片</v-subheader>
              <div class="d-flex flex-wrap px-4">
                <div 
                  v-for="(video, i) in videos" 
                  :key="i"
                  class="file-input" 
                  @click="$refs[`video${i}`][0].click()"
                >
                  <template v-if="video.src">
                    <v-icon class="delete" @click.stop="deleteProductUnit(video)">fa-times-circle</v-icon>
                    <video-player 
                      v-once
                      :ref="`videoNode${i}`" 
                      class="video-player" 
                      :playsinline="true" 
                      :options="$func.videoOption({
                        src: video.src,
                        type: video.type,
                        autoplay: true,
                        muted: true,
                        loop: true,
                        controls: false,
                      })"></video-player>
                  </template>
                  <template v-else>
                    <div class="uploadText">
                      <v-icon>fa-plus</v-icon>
                      Select File
                    </div>
                    <input 
                      type="file" 
                      :ref="`video${i}`" 
                      :accept="$accept_file_type.video"
                      onclick="this.value = null" 
                      @change="uploadVideo(i)"
                    /> 
                  </template>
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="free_images.length">
            <v-list-item-content>
              <v-subheader>公開圖片</v-subheader>
              <div class="d-flex flex-wrap px-4">
                <div 
                  v-for="(image, i) in free_images"
                  class="file-input" 
                  @click="$refs[`free_image${i}`][0] ? $refs[`free_image${i}`][0].click() : ''"
                >
                  <template v-if="image.src">
                    <v-icon class="delete" @click.stop="deleteProductUnit(image)">fa-times-circle</v-icon>
                    <v-img :src="image.src" contain/>
                  </template>
                  <template v-else>
                    <input
                      type="file"
                      :ref="`free_image${i}`"
                      :accept="$accept_file_type.image"
                      onclick="this.value = null"
                      @change="uploadImages($event, 'free_image')"
                      multiple
                    />
                    <div class="uploadText">
                      <v-icon>fa-plus</v-icon>
                      Select File
                    </div>
                  </template>
                </div>
                <div v-if="free_images.length < free_image_max" class="file-add" @click="free_images.push($func.deepCopy(unit))">
                  <v-icon>fa-plus</v-icon>
                  Add
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>

          <v-list-item 
            v-if="images.length && 
                  (['story', 'chat'].includes(product.product_type) ? product.story_type == 'image' : true )"
          >
            <v-list-item-content>
              <v-subheader>商品圖片</v-subheader>
              <div class="d-flex flex-wrap px-4">
                <div 
                  v-for="(image, i) in images"
                  class="file-input" 
                  @click="$refs[`image${i}`][0] ? $refs[`image${i}`][0].click() : ''"
                >
                  <template v-if="image.src">
                    <v-icon class="delete" @click.stop="deleteProductUnit(image)">fa-times-circle</v-icon>
                    <v-img :src="image.src" contain/>
                  </template>
                  <template v-else>
                    <input
                      type="file"
                      :ref="`image${i}`"
                      :accept="$accept_file_type.image"
                      onclick="this.value = null"
                      @change="uploadImages($event, 'image')"
                      multiple
                    />
                    <div class="uploadText">
                      <v-icon>fa-plus</v-icon>
                      Select File
                    </div>
                  </template>
                </div>
                <div v-if="images.length < image_max" class="file-add" @click="images.push($func.deepCopy(unit))">
                  <v-icon>fa-plus</v-icon>
                  Add
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-form>
    </v-card>
    <video id="upload" class="hidden"/>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import videojs from 'video.js'
export default {
  data() {
    return {
      dialog: false,
      unit: {src: '', data: '', type: '', uuid: '', new: true},
      videos: [],
      audios: [],
      images: [],
      free_images: [],
      progress: 0,
      product: {
        title: '',
        price: '',
        remark: '',
        use_time: 0,
        shelf: true,
        product_type: '',
        clothes_type: '',
        story_type: ''
      },
    }
  },
  computed: {
    ...mapState('global', ['clothes_types']),
    hint() {
      return `桃子為 <span class="d-inline-block pink--text"><div class="peach"></div>${this.product.price}</span>，換算台幣為 ${this.$func.peach2price(this.product.price)}`
    },
    formIsValid() {
      return (
        this.$rules.notEmpty(this.product.product_type) === true &&
        (this.product.product_type == 'clothes' ? this.$rules.notEmpty(this.product.clothes_type) === true : true) &&
        this.$rules.notEmpty(this.product.title) === true &&
        this.$rules.notEmpty(this.product.remark) === true &&
        this.$rules.price(this.product.price, this.product.product_type) === true &&
       (this.product.product_type == 'clothes' ? this.$rules.integer(this.product.use_time) === true : true)
      )
    },
    image_max() {
      if(!this.product.product_type) {
        return 0
      }
      return this.$product_upload_rules[this.product.product_type].image.max.charged
    },
    free_image_max() {
      if(!this.product.product_type) {
        return 0
      }
      return this.$product_upload_rules[this.product.product_type].image.max.uncharged
    }
  },
  watch: {
    dialog(newValue) {
      if(!newValue) {
        this.$refs.form.reset()
      }
    },
    'product.product_type'() {
      this.images = []
      this.free_images = []
      this.videos = []
      this.padProductUnit()
    },
    progress(value) {
      this.$root.$emit('progress-linear', value)
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    padProductUnit() {
      if (!this.product.product_type || !this.$product_upload_rules[this.product.product_type]) {
        return
      }
      let image_max = 0
      image_max = Math.min(this.$product_upload_rules.image_default, this.image_max)
      while(this.images.length < image_max) {
        this.images.push(this.$func.deepCopy(this.unit))
      }
      let free_image_max = image_max = Math.min(this.$product_upload_rules.image_default, this.free_image_max)
      while(this.free_images.length < free_image_max) {
        this.free_images.push(this.$func.deepCopy(this.unit))
      }
      let video_max = this.$product_upload_rules[this.product.product_type].video.max
      while(this.videos.length < video_max) {
        this.videos.push(this.$func.deepCopy(this.unit))
      }
    },
    deleteProductUnit(unit) {
      unit.data = unit.src = ''
    },
    async uploadVideo(i) {
      let video = event.target.files[0]
      let blob = URL.createObjectURL(video)

      // 檢查檔案大小 (限制 500MB)
      const maxSize = 500 * 1024 * 1024
      if (video.size > maxSize) {
        const sizeMB = Math.round(video.size / 1024 / 1024)
        this.$root.$emit('errorDialog', [
          '影片上傳失敗',
          `檔案大小 ${sizeMB}MB 超過限制 (最大 500MB)`,
          '請壓縮影片後再試'
        ])
        return
      }

      const validationResult = await this.$func.fileValidationWithDetails(video, this.product.product_type)
      if (!validationResult.valid) {
        this.$root.$emit('errorDialog', ['影片上傳失敗', ...validationResult.errors])
        return
      }

      this.videos[i].data = video
      this.videos[i].src = blob
      this.videos[i].type = video.type
      this.videos[i].new = true
      this.$forceUpdate()
    },
    async uploadImages(event, type) {
      const files = Array.from(event.target.files)
      const targetArray = type === 'image' ? this.images : this.free_images
      const maxCount = type === 'image' ? this.image_max : this.free_image_max

      for (const file of files) {
        if (!await this.$func.fileValidation(file)) {
          continue
        }

        // 找到第一個空的位置
        let emptyIndex = targetArray.findIndex(item => !item.data)

        // 如果沒有空位，且還沒達到上限，就新增一個
        if (emptyIndex === -1 && targetArray.length < maxCount) {
          targetArray.push(this.$func.deepCopy(this.unit))
          emptyIndex = targetArray.length - 1
        }

        // 如果已經滿了，就停止
        if (emptyIndex === -1) {
          this.$root.$emit('alert', 'warning', `已達到最大圖片數量 ${maxCount} 張`)
          break
        }

        targetArray[emptyIndex].data = file
        targetArray[emptyIndex].src = await this.$func.fileToBase64(file)
        targetArray[emptyIndex].new = true
      }

      this.$forceUpdate()
    },
    validateForm() {
      const errors = []
      const rules = this.$product_upload_rules[this.product.product_type]

      // 基本欄位驗證
      if (!this.product.product_type) {
        errors.push('請選擇商品類型')
      }
      if (this.product.product_type === 'clothes' && !this.product.clothes_type) {
        errors.push('請選擇衣物類型')
      }
      if (!this.product.title) {
        errors.push('請輸入標題')
      }
      if (!this.product.remark) {
        errors.push('請輸入備註說明')
      }
      if (this.$rules.price(this.product.price, this.product.product_type) !== true) {
        errors.push(this.$rules.price(this.product.price, this.product.product_type))
      }
      if (this.product.product_type === 'clothes' && this.$rules.integer(this.product.use_time) !== true) {
        errors.push('請輸入有效的穿著時間')
      }

      // 圖片/影片數量驗證
      if (rules) {
        const imageCount = this.images.filter(img => img.data).length
        const freeImageCount = this.free_images.filter(img => img.data).length
        const videoCount = this.videos.filter(vid => vid.data).length

        if (rules.image.min.charged > 0 && imageCount < rules.image.min.charged) {
          errors.push(`付費圖片至少需要 ${rules.image.min.charged} 張，目前只有 ${imageCount} 張`)
        }
        if (rules.image.min.uncharged > 0 && freeImageCount < rules.image.min.uncharged) {
          errors.push(`免費預覽圖至少需要 ${rules.image.min.uncharged} 張，目前只有 ${freeImageCount} 張`)
        }
        if (rules.video.min > 0 && videoCount < rules.video.min) {
          errors.push(`影片至少需要 ${rules.video.min} 部，目前只有 ${videoCount} 部`)
        }
      }

      return errors
    },
    async submit() {
      const errors = this.validateForm()
      if (errors.length > 0) {
        this.$root.$emit('errorDialog', ['上傳失敗，請檢查以下項目：', ...errors.map(e => `• ${e}`)])
        return
      }
      this.$root.$emit('loading', true)
      let formData = new FormData()
      // let oldPrice = this.product.price
      // this.product.price = this.$func.price2peach(this.product.price, this.product.product_type)
      Object.keys(this.product).forEach(key => formData.append(key, (typeof this.product[key] == 'boolean') ? +this.product[key] : this.product[key]))
      let config = {
        url: '/portal/product',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        method: 'POST',
        data: formData,
        onUploadProgress: e => {
          this.progress = e.loaded / e.total * 100
        }
      }
      if(this.product.product_type != 'story' || (['story', 'chat'].includes(this.product.product_type) == 'story' && this.product.story_type == 'image')) {
        this.images.filter(image => image.data).forEach(image => {
          formData.append(['story', 'chat'].includes(this.product.product_type) ? 'image' : 'images[]', image.data)
        })
      }
      this.free_images.filter(image => image.data).forEach(image => {
        // clothes products don't accept free_images[]
        formData.append(['photo'].includes(this.product.product_type) ? 'free_images[]' : 'images[]', image.data)
      })
      if(this.product.product_type != 'story' || (['story', 'chat'].includes(this.product.product_type) && this.product.story_type == 'video')) {
        this.videos.filter(video => video.data).forEach(video => {
          formData.append(['clothes'].includes(this.product.product_type) ? 'videos[]' : 'video', video.data)
        })
      }
      if(!formData.has('videos[]')) {
        formData.append('videos[]', [])
      }
      this.axios(config).then(response => {
        this.$root.$emit('alert', 'success', '新增成功')
        this.dialog = false
        this.$emit('refresh')
      }).catch(e => {
        console.error('Upload error:', e.response)
        let errorMessage = '新增失敗，請稍後再試'
        if (e.response && e.response.data) {
          if (e.response.data.message) {
            errorMessage = e.response.data.message
          } else if (e.response.data.errors) {
            // Laravel validation errors
            const errors = Object.values(e.response.data.errors).flat()
            errorMessage = errors.join('\n')
          }
        }
        this.$root.$emit('errorDialog', ['上傳失敗', errorMessage])
      }).finally(() => {
        this.progress = 0
        this.$root.$emit('loading', false)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.newProduct {
  .video-player {
    width: 100%;
  }
}
</style>